import React from "react";
import { StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionHeading } from "@/components/sections/SectionHeading";
import { NRI_PRODUCTS } from "@/data/content";
import { ArrowRight } from "lucide-react";
import { useWaitlist } from "@/context/WaitlistContext";

export const NRIStack = () => {
  const { openWaitlist } = useWaitlist();
  return (
    <section id="nri-stack" data-testid="nri-stack" className="relative bg-gradient-to-b from-ivory to-ivory-light py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          overline="For NRIs"
          title="Gold that crosses every border"
          accentWord="every border"
          subtitle="The diaspora stack — built for Indians abroad who want to hold, gift and send Indian gold without the paperwork maze."
        />

        <StaggerGroup className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" stagger={0.09}>
          {NRI_PRODUCTS.map((p, i) => (
            <StaggerItem key={p.name}>
              <div className="glass-card group flex h-full flex-col rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_-12px_rgba(212,175,55,0.28)]">
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/12">
                  <p.icon className="h-6 w-6 text-gold" strokeWidth={1.8} />
                </div>
                <h3 className="font-serif text-xl font-normal text-charcoal">{p.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-charcoal-soft">{p.pitch}</p>
                <button
                  data-testid={`nri-learn-more-${i}`}
                  onClick={() => openWaitlist("nri")}
                  className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-gold transition-all hover:gap-2"
                >
                  Learn more <ArrowRight className="h-4 w-4" />
                </button>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
